import styled from 'styled-components'

export const SubTableWrapper = styled.div`
	border: 1px solid rgba(255, 255, 255, 0.15);
	border-radius: 15px;
	background: linear-gradient(135deg, rgba(31, 41, 55, 0.6) 0%, rgba(17, 24, 39, 0.6) 100%);
	box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
`
export const TopRow = styled.div`
	border-bottom: 1px solid rgba(255, 255, 255, 0.15);

	& > * {
		border: none;
		height: 56px;

		@media (max-width: 700px) {
			height: fit-content;
		}
	}
`
export const MainContent = styled.div`
	padding: 30px;

	@media (max-width: 700px) {
		background: linear-gradient(135deg, rgba(31, 41, 55, 0.8) 0%, rgba(17, 24, 39, 0.8) 100%);
	}
`
export const Title = styled.div`
	font-weight: 700;
	font-size: 28px;
	margin-left: 45px;
	margin-bottom: 20px;
	color: #f3f4f6;
`
